import React from "react";
import { useTranslation } from "react-i18next";
import { AlertTriangle } from "lucide-react";
import Button from "./Button";
import Modal from "./Modal";
import { color, radius } from "../../styles/theme";

const ConfirmModal = ({
  title,
  message,
  confirmText,
  cancelText,
  danger = false,
  loading = false,
  onConfirm,
  onCancel,
  children,
}) => {
  const { t } = useTranslation("common");
  const resolvedTitle = title ?? t("confirmModal.defaultTitle");
  const resolvedConfirm = confirmText ?? t("confirmModal.defaultConfirm");
  const resolvedCancel = cancelText ?? t("confirmModal.defaultCancel");
  return (
  <Modal
    onClose={onCancel}
    busy={loading}
    maxWidth={400}
    footer={
      <>
        <Button variant="secondary" onClick={onCancel} disabled={loading}>{resolvedCancel}</Button>
        <Button variant={danger ? "danger" : "primary"} onClick={onConfirm} disabled={loading}>
          {loading ? t("actions.pleaseWait") : resolvedConfirm}
        </Button>
      </>
    }
  >
    <div style={s.wrap}>
      <span style={{ ...s.iconBadge, ...(danger ? {} : s.iconBadgeNeutral) }}>
        <AlertTriangle size={18} strokeWidth={2} />
      </span>
      <div style={{ minWidth: 0, flex: 1 }}>
        <h4 style={s.title}>{resolvedTitle}</h4>
        <p style={s.message}>{message}</p>
        {children}
      </div>
    </div>
  </Modal>
  );
};

const s = {
  wrap: { display: "flex", gap: 14, alignItems: "flex-start" },
  iconBadge: {
    width: 36, height: 36, borderRadius: radius.sm, background: color.danger50, color: color.danger500,
    display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
  },
  iconBadgeNeutral: { background: color.primary50, color: color.primary600 },
  title: { margin: "2px 0 6px", fontSize: 14.5, fontWeight: 700, color: color.textPrimary },
  message: { margin: 0, fontSize: 13, color: color.textSecondary, lineHeight: 1.55 },
};

export default ConfirmModal;
